module.exports = __webpack_public_path__ + "static/media/c58.a7a171a8.png";